import { LayerApiService } from './../../../../../model/api-services/layer-api.service';
import { ParsePathParams } from './../../../../../model/router-params';
import { AnyHandler } from 'src/app/types/@types/sl-v-types';
import { ArcgisService, ArcGIS_LayerLookup, ArcGIS_LayerLookupInfo, ArcGIS_LayerUpsertParams } from '../../../../../model/api-services/arcgis/arcgis.service';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, HostBinding, OnInit } from '@angular/core';
import { GeoJSONFeature } from 'mapbox-gl';
import { DateUtil } from 'src/app/model/dateutil';
import { DateQualifierService } from 'src/app/model/api-services/qualifiers/date-qualifier.service';
import { SLLayer } from 'src/app/model/sl-layer';
import { AppSelectorModule } from "../../../../../app-selector/app-selector.module";
import { TestsModule } from "../../../../../tests/tests.module";
import { UiElementsModule } from "../../../../../common-modules/ui-elements.module";
import { ViewStackViewUnencapsulatedComponent } from "../../../../../components/view-stack/view-stack-view-unencapsulated/view-stack-view-unencapsulated.component";
import { ActivatedRoute, UrlSegment } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { Decorable, Dict } from 'src/app/types/decorable';
import { ModalMessagerService } from 'src/app/modal-messager/modal-messager.service';
import { IExternalMessageReceiver, SandboxMessengerService, SBExternalMessage } from 'src/app/services/sandbox-messenger.service';

export type ArcgisServiceListItem = {
  name: string;
  type: string;
}
export type WFSImportState = 'needs-url' | 'needs-folder' | 'needs-service' | 'needs-layer' | 'ready';
export type toolModes = WFSImportState | ''
export type ARCGISCrumb = { label: string, state: WFSImportState, data?: any };
@Component({
  selector: 'app-arcgis-config',
  templateUrl: './arcgis-config.component.html',
  styleUrls: ['./arcgis-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArcgisConfigComponent implements OnInit, IExternalMessageReceiver {
  @HostBinding('class.work-pane') workPaneCSS = true;
  public folders = [];
  public services = [];
  public currentFolder: undefined | string;
  public selectedService: undefined | ArcgisServiceListItem;
  public currentState: WFSImportState = 'needs-url';
  public activeTool = 'needs-url';
  public srid: number = NaN;
  public srs: string = '';
  public dayOfMonth = 1;
  public dayOfWeek = 1;

  constructor(private cdr: ChangeDetectorRef, private arcgis: ArcgisService, protected route: ActivatedRoute, protected layerSvc: LayerApiService, protected messager: ModalMessagerService, protected sbmsgr: SandboxMessengerService) {
    this.sbmsgr.RegisterHandler(this, 'sl-app-message');
  }
  private _ready = false;
  private _name: string = '';
  private _layerId: any;
  public slLayer: SLLayer;

  public get layerTitle(): string {
    if (!this.slLayer || !this._ready) return '';
    return `Layer ${this.slLayer.id} : ${this.slLayer.name}`;
  }

  public set name(name: string) {
    this._name = name;
    this.Refresh();
  }
  public get name(): string {
    return this._name;
  }
  private _description: string = '';
  public set description(desc: string) {
    this._description = desc;
    this.Refresh();
  }
  public get description(): string {
    return this._description;
  }
  public get hasId(): boolean {
    return (!!this._layerId)
  }
  public numFeatures: number = 0;

  public layerInfo: ArcGIS_LayerLookupInfo;
  private _arcGISURL: string = '';
  public set arcGISURL(url: string) {
    this._arcGISURL = url;
    this.folders = [];
    this.currentFolder;
    this.services = [];
    this.Refresh();
  }
  public get arcGISURL(): string {
    return this._arcGISURL;
  }
  public timingOption: 'manual' | 'weekly' | 'monthly' = 'manual';
  public get timingIsWeekly(): boolean {
    return this.timingOption === 'weekly';
  }
  public get timingIsMonthly(): boolean {
    return this.timingOption === 'monthly';
  }

  private _selectedLayer: any = '';
  public set selectedLayer(lyr: any) {
    this._selectedLayer = lyr;
    this.Refresh();
  }
  public get selectedLayer(): any {
    return this._selectedLayer;
  }
  public selectedLayerURL = '';
  public GetBreadCrumbs(): Array<{ label: string, state: WFSImportState, data?: any }> {
    // const info = this.arcgis.ParseServiceURL(this._arcGISURL);
    const firstCrumb: ARCGISCrumb = { label: 'URL', state: 'needs-url' }
    const folders: ARCGISCrumb = { label: 'Folders', state: 'needs-folder' }
    const folder: ARCGISCrumb = { label: this.currentFolder!, state: 'needs-service', data: this.currentFolder };
    const service: ARCGISCrumb = { label: this.GetServiceName(this.selectedService), state: 'needs-layer', data: this.selectedService };
    const layer: ARCGISCrumb = { label: this.selectedLayer?.name, state: 'ready', data: this.selectedLayer }
    switch (this.currentState) {
      case 'needs-url':
        return [];
      case 'needs-folder':
        return [firstCrumb, folders];
      case 'needs-service':
        return [firstCrumb, folders, folder];
      case 'needs-layer':
        return [firstCrumb, folders, folder, service];
      case 'ready':
        if (this.currentFolder === '') return [firstCrumb, service, layer];
        return [firstCrumb, folders, folder, service, layer];
      default:
        return [firstCrumb];
    }
  }
  public FollowCrumb(crumb?: ARCGISCrumb) {
    const info = this.arcgis.ParseServiceURL(this._arcGISURL);
    switch (crumb?.state) {
      case 'needs-url':
        this.currentFolder = undefined;
        this.selectedService = undefined;
        this.selectedLayer = undefined;
        this.currentState = crumb.state;
        this.activeTool = this.currentState;
        this.Refresh();
        break;
      case 'needs-folder':
        this.currentFolder = undefined;
        this.selectedService = undefined;
        this.selectedLayer = undefined;
        this.currentState = crumb.state;
        this.activeTool = this.currentState;
        this.Refresh();
        break;
      case 'needs-service':
        this.selectedService = undefined;
        this.selectedLayer = undefined;
        this.currentState = crumb.state;
        this.activeTool = this.currentState;
        this.Refresh();
        break;
      case 'needs-layer':
        this.selectedLayer = undefined;
        this.currentState = crumb.state;
        this.activeTool = this.currentState;
        this.Refresh();
        break;
      case 'ready':
        this.activeTool = 'info';
        this.Refresh();
        return;
    }
    this.GetInfo(this.currentState);
  }
  public SelectFolder(folder: any) {
    this.messager.Progress('Loading info for folder ' + folder, false, .5, 'Folder Retrieval');
    this.arcgis.GetFolder(this._arcGISURL, folder, (response) => {
      this.currentState = 'needs-service';
      this.activeTool = this.currentState;
      this.currentFolder = folder;
      for (const service of response.services) {
        if (service.name.indexOf(this.currentFolder + '/') == 0) {
          service.name = service.name.substring(this.currentFolder.length + 1);
        }
      }
      this.services = response.services;
      this.messager.Progress('Folder retrieved' + folder, true, 1, 'Folder Retrieval');

      this.Refresh();
    });
  }
  public GetInfo(state?: WFSImportState) {
    if (this._arcGISURL === '') return;
    if (this._arcGISURL.indexOf('?') > -1) {
      this._arcGISURL = this._arcGISURL.split('?').shift();
      this.Refresh();
    }

    const parts = this.arcgis.ParseServiceURL(this._arcGISURL);

    if (!!state) {
      this.currentState = state;
    } else {
      if (this._arcGISURL.length > 0) {
        this.currentState = 'needs-folder';
      }
      if (!!parts.folder || parts.folder === '') {
        this.currentFolder = parts.folder ?? '/';
        if (!parts.additionalParams.length || !parts.service) {
          this.currentState = 'needs-service';
          this.activeTool = this.currentState;
        }
      }
      if (!!parts.service?.type) {
        this.selectedService = parts.service;
        if (!parts.additionalParams[0]) {
          this.currentState = 'needs-layer';
          this.activeTool = this.currentState;
        }

        if (!!parts.additionalParams.length) {
          this.currentState = 'ready';
          this.activeTool = 'info';
          this.selectedLayer = parts.additionalParams[0];


        }
      }
      this.Refresh();
    }
    switch (this.currentState) {
      case 'needs-url':
        break;
      case 'needs-folder':
        this.arcgis.GetFolders(this._arcGISURL, (response) => {
          console.log(response);
          if (response.folders) {
            this.currentFolder = undefined;
            this.folders = response.folders;
            this.activeTool = 'needs-folder';
            this.Refresh();
          }
        });
        break;
      case 'needs-service':
        this.SelectFolder(this.currentFolder);
        break;
      case 'needs-layer':
      case 'ready':
        this.SelectService(this.selectedService);
        break;
    }
    this.Refresh();
    /*this.arcgis.GetInfo(this._arcGISURL, (response) => {
      if (!!response.layers) {
        this.layers = this.arcgis.GetDocumentLayers(response);
        this.cdr.markForCheck();
        this.Refresh();
      }
    });*/
  }
  GetIsSupportedService(service: any) {
    return ['mapserver', 'featureserver'].indexOf(service.type.toLowerCase()) > -1;
  }
  GetServiceName(service?: ArcgisServiceListItem) {
    if (!service) return '';
    // if (!this.currentFolder) return '';
    return service.name; //.substring(this.currentFolder.length + 1);
  }
  GetServiceIcon(service: ArcgisServiceListItem) {
    switch (service.type) {
      case 'MapServer':
        return 'fa-map';
      case 'FeatureServer':
        return 'fa-map-marker-alt';
    }
  }
  SelectService(service: ArcgisServiceListItem) {
    this.messager.Progress('Retrieving Service info for ' + service.name, false, .5, 'Service Retrieval');

    this.arcgis.GetService(this._arcGISURL, this.currentFolder, service, (response) => {
      if (!!response.type && (response.type === 'Feature Layer')) {
        this.layers = [response];

      } else {
        this.layers = response.layers;
      }
      this.selectedService = service;
      this.messager.Progress('Service ' + service.name + ' retrieved', true, 1, 'Service Retrieval');
      if (this.selectedLayer) {
        this.SelectLayer(this.layers.find(item => item.id == Number(this.selectedLayer)));
      } else {
        this.currentState = 'needs-layer';
        this.activeTool = this.currentState;
      }
      this.Refresh();
    })
  }
  public MakeLayerURL(layer: ArcGIS_LayerLookupInfo) {
    this.layerInfo = layer;
    this.name = layer.name;
    let layerURL = this.arcgis.GetLayerPath(this._arcGISURL, this.currentFolder, this.selectedService, layer.id);
    return layerURL;
  }
  public features: Array<GeoJSONFeature>;
  public attributes: Array<any>;
  public includedFields = [];
  public SelectLayer(layer: ArcGIS_LayerLookupInfo) {
    this.includedFields = [];
    this.srs = '';
    this.srid = NaN;
    this.features = undefined;
    this.selectedLayerURL = this.MakeLayerURL(layer);
    this.messager.Progress('Retrieving ArcGIS Layer Info for ' + layer.name, false, .5, 'ArcGIS Layer Info Retrieval');

    this.arcgis.GetLayer(this.selectedLayerURL, (response) => {
      this.messager.Progress('ArcGIS Layer Info for ' + layer.name + ' retrieved', true, 1, 'ArcGIS Layer Info Retrieval');

      this.description = response.description ? response.description : '';
      this.description += response.copyrightText ? "\n©" + response.copyrightText : '';
      this.attributes = response.fields;
      for (const field of this.attributes) {
        this.includedFields.push(field.name);
      }
      this.selectedLayer = response;
      this.QueryLayer(true, (response) => {
        this.numFeatures = response.count;
        this.GetSRS();
        this.Refresh();
      });

    });


  }
  public ShowTiming() {
    this.activeTool = 'timing';
    this.Refresh();
  }
  public ShowAttributes() {
    if (!this.attributes) {
      this.activeTool = '';
    } else {
      this.activeTool = 'attributes';
    }
    this.Refresh();
  }
  public LoadPreview() {
    this.activeTool = 'preview';
    this.QueryLayerTopX(20, (response) => {
      if (typeof response.features === 'string') response.features = response.features.split(',');
      this.features = response.features;
      this.ReduceColumns();
      this.Refresh();
    })
  }
  public ReduceColumns() {
    if (!this.features) return;
    if (typeof this.features === 'string') return;
    this.features.forEach((value, index, array) => {
      const newObj: any = {};
      for (const key of this.includedFields) {
        if (value.properties.hasOwnProperty(key)) {
          newObj[key] = value.properties[key];
        }
      }
      value.properties = newObj;
    });


  }

  public QueryLayer(countOnly: boolean, handler: AnyHandler) {
    this.arcgis.QueryLayer(this.selectedLayerURL, {}, countOnly, handler);
  }
  public QueryLayerTopX(topX: number, handler: AnyHandler) {

    const outFields = '*';
    this.arcgis.QueryLayer(this.selectedLayerURL, { where: '1=1', outFields: outFields, resultRecordCount: topX, resultOffset: 0, returnGeometry: true }, false, handler);
  }
  public GetSRS() {
    const spatialReference = this.selectedLayer?.sourceSpatialReference;
    if (!spatialReference) return;
    const srId = spatialReference.latestWkid ? spatialReference.latestWkid : spatialReference.wkid;
    this.srid = srId;
    this.arcgis.GetSRS(srId, (response) => {
      this.srs = response.sr;
      this.currentState = 'ready';
      this.activeTool = 'info';
      this.Refresh();
    });
  }
  public ShowInfo() {
    this.activeTool = 'info'
    this.Refresh();
  }


  public IsAllFieldsIncluded(): boolean {
    return this.attributes.length === this.includedFields.length;
  }

  public ToggleAllFieldsIncluded() {
    if (this.IsAllFieldsIncluded() === true) {
      this.includedFields = [];

    } else {
      const fields = [];
      for (const attr of this.attributes) {
        fields.push(attr.name);
      }
      this.includedFields = fields;
    }
    this.Refresh();
  }

  public IsFieldIncluded(fieldName: string) {
    return this.includedFields.indexOf(fieldName) > -1;
  }
  public ToggleFieldInclusion(fieldName) {
    const index = this.includedFields.indexOf(fieldName);
    if (index > -1) {
      this.includedFields.splice(index, 1);
    } else {
      this.includedFields.push(fieldName);
    }
    this.Refresh();
  }
  public GetType(field) {
    return this.arcgis.GetPGType(field);
  }
  public GetActiveToolTitle() {
    switch (this.activeTool) {
      case 'info':
        return 'Info';
      case 'attributes':
        return 'Attributes';
      case 'preview':
        return 'Data Preview - First 20 Records';
      case 'timing':
        return "Refresh Schedule";
      case 'needs-service':
        return "Select a service";
    }
  }

  public SubmitLayer() {
    let layer: any = {};
    layer.source = this.MakeLayerURL(this.selectedLayer);
    layer.metadata = this.layerInfo;
    layer.fields = this.includedFields;
    layer.name = this.name;
    layer.description = this.description;

  }

  public get hasLayers(): boolean {
    return this.layers.length > 0;
  }
  public layers: ArcGIS_LayerLookup = [];
  ngOnInit(): void {

    const params = ParsePathParams('data/arcgis/config', this.route);
    if (!!params?.layer) {
      this.LoadInfo(params.layer);
    }
    this.sbmsgr.Register(document.location.href, 'register-app');
    this.sbmsgr.SendMessage(this.sbmsgr.MakeMessage('app-ready', { action: 'SL-App_ReadyToConnect', src: document.location.href }))
    this._ready = true;


  }
  Refresh(): void {
    if (this._ready) {
      this.cdr.detectChanges();
    }
  }

  Upsert(): void {
    const params: ArcGIS_LayerUpsertParams = {
      name: this.name,
      description: this.description,
      src: this.MakeLayerURL(this.layerInfo),
      field_whitelist: this.includedFields.slice(0),
      max_records: this.numFeatures,
      refresh_interval: this.timingOption
    }

    const today = DateQualifierService.DateToDB(new Date());
    switch (this.timingOption) {
      case 'manual':
        break;
      case 'monthly':
        params.refresh_day = this.dayOfMonth;
        params.next_refresh = today;
        break;
      case 'weekly':
        params.refresh_day = this.dayOfWeek;
        params.next_refresh = today;
        break;

    }
    const hadId = this.hasId;
    if (this.hasId) {
      params.layerid = this._layerId;
    }
    if (!!this.srs) {
      params.srs = this.srs;
    }
    if (!!this.srid) {
      params.srsWkId = this.srid;
    }
    if (hadId) {
      this.messager.Progress('Re-importing content', false, .5, 'Updating...');
    } else {
      this.messager.Progress('Creating layer and importing content', false, .5, 'Creating new layer ...');

    }
    this.arcgis.UpsertLayer(this.MakeLayerURL(this.layerInfo), params).then((result) => {

      if (result?.response?.layer) {
        const layer = result.response.layer;
        this._layerId = layer.id;
        if (hadId) {
          this.messager.CancelProgress('Updating...');
          this.messager.Notify('Layer update complete');
        } else {
          this.messager.CancelProgress('Creating new layer ...');
          this.messager.Notify('Layer creation and import complete');

        }
      } else {
        if (hadId) {
          this.messager.CancelProgress('Updating...');
          this.messager.Notify('There was a problem updating the layer', true, 'Layer not updated!');
          console.log(result);
        } else {
          this.messager.CancelProgress('Creating new layer ...');
          this.messager.Notify('There was a problem importing this layer', true, 'Layer not imported!');
          console.log(result);
        }
      }
      if (!!(result?.response?.report_id)) {
        this.sbmsgr.SendMessage(this.sbmsgr.MakeMessage('redirect', { layerId: this._layerId, page: 'import/reports/layers/report:' + result.response.report_id + '/' }));
        return;
      }
      if (!hadId && this.hasId) {
        if (this.hasId) {
          this.LoadInfo(this._layerId);
        }

      }
      if (this.hasId) {
        this.sbmsgr.SendMessage(this.sbmsgr.MakeMessage('redirect', { layerId: this._layerId, page: 'general' }));
      }
      // ToDo: handle result
    })
  }
  LoadInfo(layerId) {
    this.messager.Progress('Loading SimpleLayers Layer info', false, .5, 'Loading ...');
    this.layerSvc.LoadLayerById(layerId, null, false).then((result) => {
      this.messager.Progress('Layer SimpleLayers Layer info retrieved', true, 1, 'Loading ...');

      this.ShowLayer(result)
    }).catch((reason) => {
      this.messager.CancelProgress('Loading ...');
      this.messager.Notify('There was a problem loading this layer: <p>' + reason, true);
    })


  }
  ShowLayer(layer: SLLayer) {
    this.slLayer = layer;
    this._layerId = layer.id;
    console.log(this.slLayer);
    const custom = this.slLayer.customData;
    this.arcGISURL = custom.src;
    this.dayOfMonth = Number(custom.refresh_day);
    this.dayOfWeek = Number(custom.refresh_day) % 7;
    this.timingOption = custom.refresh_interval;

    // this.refresh_next = custom.next_refresh;
    //this.refresh_interval = custom.refresh_interval;

    this.GetInfo();

    this.includedFields = custom.field_whitelist;

    //this.layer = custom.layer
    this.Refresh();

  }
  HandleExternalMessage(message: SBExternalMessage): void {
    console.log(message);
  }
}
